(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3513],{

/***/ 12963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumbs_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/useSlotProps.js + 4 modules
var useSlotProps = __webpack_require__(56504);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 2 modules
var useThemeProps = __webpack_require__(27623);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/MoreHoriz.js



/**
 * @ignore - internal component.
 */

/* harmony default export */ var MoreHoriz = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz'));
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(49990);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Breadcrumbs/BreadcrumbCollapsed.js


const _excluded = ["slots", "slotProps"];







const BreadcrumbCollapsedButton = (0,styled/* default */.ZP)(ButtonBase/* default */.Z)(({
  theme
}) => (0,esm_extends/* default */.Z)({
  display: 'flex',
  marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
  marginRight: `calc(${theme.spacing(1)} * 0.5)`
}, theme.palette.mode === 'light' ? {
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.grey[700]
} : {
  backgroundColor: theme.palette.grey[700],
  color: theme.palette.grey[100]
}, {
  borderRadius: 2,
  '&:hover, &:focus': (0,esm_extends/* default */.Z)({}, theme.palette.mode === 'light' ? {
    backgroundColor: theme.palette.grey[200]
  } : {
    backgroundColor: theme.palette.grey[600]
  }),
  '&:active': (0,esm_extends/* default */.Z)({
    boxShadow: theme.shadows[0]
  }, theme.palette.mode === 'light' ? {
    backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.grey[200], 0.12)
  } : {
    backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.grey[600], 0.12)
  })
}));
const BreadcrumbCollapsedIcon = (0,styled/* default */.ZP)(MoreHoriz)({
  width: 24,
  height: 16
});

/**
 * @ignore - internal component.
 */
function BreadcrumbCollapsed(props) {
  const {
      slots = {},
      slotProps = {}
    } = props,
    otherProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = props;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbCollapsedButton, (0,esm_extends/* default */.Z)({
      focusRipple: true
    }, otherProps, {
      ownerState: ownerState,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbCollapsedIcon, (0,esm_extends/* default */.Z)({
        as: slots.CollapsedIcon,
        ownerState: ownerState
      }, slotProps.collapsedIcon))
    }))
  });
}
 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_BreadcrumbCollapsed = (BreadcrumbCollapsed);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Breadcrumbs/breadcrumbsClasses.js


function getBreadcrumbsUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiBreadcrumbs', slot);
}
const breadcrumbsClasses = (0,generateUtilityClasses/* default */.Z)('MuiBreadcrumbs', ['root', 'ol', 'li', 'separator']);
/* harmony default export */ var Breadcrumbs_breadcrumbsClasses = (breadcrumbsClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js


const Breadcrumbs_excluded = ["children", "className", "component", "slots", "slotProps", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"];












const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    li: ['li'],
    ol: ['ol'],
    separator: ['separator']
  };
  return (0,composeClasses/* default */.Z)(slots, getBreadcrumbsUtilityClass, classes);
};
const BreadcrumbsRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiBreadcrumbs',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    return [{
      [`& .${Breadcrumbs_breadcrumbsClasses.li}`]: styles.li
    }, styles.root];
  }
})({});
const BreadcrumbsOl = (0,styled/* default */.ZP)('ol', {
  name: 'MuiBreadcrumbs',
  slot: 'Ol',
  overridesResolver: (props, styles) => styles.ol
})({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  padding: 0,
  margin: 0,
  listStyle: 'none'
});
const BreadcrumbsSeparator = (0,styled/* default */.ZP)('li', {
  name: 'MuiBreadcrumbs',
  slot: 'Separator',
  overridesResolver: (props, styles) => styles.separator
})({
  display: 'flex',
  userSelect: 'none',
  marginLeft: 8,
  marginRight: 8
});
function insertSeparators(items, className, separator, ownerState) {
  return items.reduce((acc, current, index) => {
    if (index < items.length - 1) {
      acc = acc.concat(current, /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbsSeparator, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        children: separator
      }, `separator-${index}`));
    } else {
      acc.push(current);
    }
    return acc;
  }, []);
}
const Breadcrumbs = /*#__PURE__*/react.forwardRef(function Breadcrumbs(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiBreadcrumbs'
  });
  const {
      children,
      className,
      component = 'nav',
      slots = {},
      slotProps = {},
      expandText = 'Show path',
      itemsAfterCollapse = 1,
      itemsBeforeCollapse = 1,
      maxItems = 8,
      separator = '/'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Breadcrumbs_excluded);
  const [expanded, setExpanded] = react.useState(false);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    expanded,
    expandText,
    itemsAfterCollapse,
    itemsBeforeCollapse,
    maxItems,
    separator
  });
  const classes = useUtilityClasses(ownerState);
  const collapsedIconSlotProps = (0,useSlotProps/* default */.Z)({
    elementType: slots.CollapsedIcon,
    externalSlotProps: slotProps.collapsedIcon,
    ownerState
  });
  const listRef = react.useRef(null);
  const renderItemsBeforeAndAfter = allItems => {
    const handleClickExpand = () => {
      setExpanded(true);

      // The clicked element received the focus but gets removed from the DOM.
      // Let's keep the focus in the component after expanding.
      // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
      // By moving it to some link/button at least we have some announcement.
      const focusable = listRef.current.querySelector('a[href],button,[tabindex]');
      if (focusable) {
        focusable.focus();
      }
    };

    // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem
    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (false) {}
      return allItems;
    }
    return [...allItems.slice(0, itemsBeforeCollapse), /*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumbs_BreadcrumbCollapsed, {
      "aria-label": expandText,
      slots: {
        CollapsedIcon: slots.CollapsedIcon
      },
      slotProps: {
        collapsedIcon: collapsedIconSlotProps
      },
      onClick: handleClickExpand
    }, "ellipsis"), ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)];
  };
  const allItems = react.Children.toArray(children).filter(child => {
    if (false) {}
    return /*#__PURE__*/react.isValidElement(child);
  }).map((child, index) => /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    className: classes.li,
    children: child
  }, `child-${index}`));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbsRoot, (0,esm_extends/* default */.Z)({
    ref: ref,
    component: component,
    color: "text.secondary",
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbsOl, {
      className: classes.ol,
      ref: listRef,
      ownerState: ownerState,
      children: insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_Breadcrumbs = (Breadcrumbs);

/***/ }),

/***/ 99690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12963);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23795);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);





function MyBreadcrumbs(_ref) {
  var routeList = _ref.routeList,
      inverted = _ref.inverted,
      t = _ref.t;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    "aria-label": "breadcrumb",
    separator: "\u203A",
    sx: {
      '.MuiBreadcrumbs-separator': {
        color: 'white'
      }
    },
    children: routeList.map(function (route) {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        underline: "hover",
        color: inverted ? route.isActive ? '#DDDDDD' : 'white' : route.isActive ? 'text.primary' : "inherit",
        href: route.href,
        children: !!t ? t("home:".concat(route.label)) : route.label
      }, route.label);
    })
  });
}

/***/ }),

/***/ 8930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93946);
/* harmony import */ var _mui_material_FormControl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94054);
/* harmony import */ var _mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33841);
/* harmony import */ var _mui_material_OutlinedInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37058);
/* harmony import */ var _mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87109);
/* harmony import */ var _mui_icons_material_Search__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42761);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);











function MyInput(_ref) {
  var inputName = _ref.inputName,
      placeHolder = _ref.placeHolder,
      value = _ref.value,
      onChange = _ref.onChange,
      handleClick = _ref.handleClick,
      margin = _ref.margin,
      onKeyDown = _ref.onKeyDown;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    style: {
      marginTop: margin ? 10 : null
    },
    sx: {
      width: '25ch'
    },
    variant: "outlined",
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      size: "small",
      style: {
        fontFamily: 'Montserrat',
        fontWeight: 500
      },
      htmlFor: inputName,
      children: placeHolder
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_OutlinedInput__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      size: "small",
      id: inputName,
      type: 'text',
      value: value,
      onChange: onChange,
      onKeyDown: function onKeyDown(ev) {
        if (ev.key === 'Enter') {
          // Do code here
          handleClick();
          ev.preventDefault();
        }
      },
      endAdornment: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        position: "end",
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          "aria-label": "toggle password visibility",
          onClick: handleClick // onMouseDown={handleMouseDownPassword}
          ,
          edge: "end",
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_icons_material_Search__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        })
      }),
      label: placeHolder
    })]
  });
}

/***/ }),

/***/ 68721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ AllBrands; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(27812);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(80819);
/* harmony import */ var components_blocks_Container__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(75046);
/* harmony import */ var layouts_Default__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87607);
/* harmony import */ var components_MyBreadcrumbs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99690);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97212);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(78462);
/* harmony import */ var components_MyInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8930);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90296);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41248);
/* harmony import */ var lib_features_brandSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77078);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57731);
/* harmony import */ var _data_config_json__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56513);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3580);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_utils_helper__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(35944);





















var BRANDS_ROUTE = _data_config_json__WEBPACK_IMPORTED_MODULE_10__/* .brand.route */ .UQ.B;
var BREAD_ROUTE = [{
  label: 'Home',
  href: '/',
  isActive: false
}, {
  label: 'brands_all_brands',
  href: '/allBrands',
  isActive: true
}];
var useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function (theme) {
  return {
    root: {
      display: "flex",
      flexDirection: "row",
      padding: 0
    },
    list: {
      paddingLeft: 10,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      paddingTop: 'unset',
      marginBottom: 20
    },
    mobileList: {
      width: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      paddingTop: 'unset',
      marginBottom: 20
    }
  };
});
var __N_SSP = true;
function AllBrands(_ref) {
  var page = _ref.page;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  var classes = useStyles();
  var brands = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function (state) {
    return state.brand.brands;
  });
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      loaded = _useState[0],
      setLoaded = _useState[1];

  function initBrand() {
    return _initBrand.apply(this, arguments);
  }

  function _initBrand() {
    _initBrand = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
      var sort, page, filter;
      return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              sort = {};
              page = 1;
              filter = {};
              _context2.next = 5;
              return dispatch((0,lib_features_brandSlice__WEBPACK_IMPORTED_MODULE_8__/* .getPaginatedBrandsThunk */ .XZ)({
                page: page,
                filter: filter,
                sort: sort
              }));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _initBrand.apply(this, arguments);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    console.log('at allbrands: ', brands.length);

    if (brands[0].name === 'Test') {
      initBrand();
    } else {
      setLoaded(true);
    }

    return function () {
      console.log('clean up initBrand');
    };
  }, [brands]);

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      brandsName = _useState2[0],
      setBrandsName = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      allCaps = _useState3[0],
      setAllCaps = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
    arrangedList: [[{
      name: ' ',
      id: ''
    }]],
    previousCap: ''
  }),
      list1 = _useState4[0],
      setList1 = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
    arrangedList: [[{
      name: ' ',
      id: ''
    }]],
    previousCap: ''
  }),
      list2 = _useState5[0],
      setList2 = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
    arrangedList: [[{
      name: ' ',
      id: ''
    }]],
    previousCap: ''
  }),
      list3 = _useState6[0],
      setList3 = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
      searchInput = _useState7[0],
      setSearchInput = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)('ALL'),
      selectedType = _useState8[0],
      setSelectedType = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
      selectedTag = _useState9[0],
      setSelectedTag = _useState9[1];

  var removeDuplicates = function removeDuplicates(arr) {
    return arr.filter(function (item, index) {
      return arr.indexOf(item) === index;
    });
  };

  var reOrderList = function reOrderList(nameList, tagChange) {
    var capList = [];
    var alphaList = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var displayList = [];

    if (nameList.length > 0) {
      if (nameList[0]['name'] !== undefined) {
        displayList = nameList.filter(function (item) {
          return /^[0-9]+$/.test(item['name'][0]);
        });
      }
    }

    if (displayList.length > 0) {
      capList.push('0-9');
    }

    var _loop = function _loop(i) {
      var _displayList;

      var current = alphaList[i];
      var tempList = [];
      tempList = nameList.filter(function (item) {
        return !!item['name'] && !!item['name'][0] ? item['name'][0].toUpperCase() === current : false;
      });

      if (tempList !== undefined) {
        if (tempList.length > 0) {
          capList.push(alphaList[i]);
        }
      }

      (_displayList = displayList).push.apply(_displayList, (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(tempList));
    };

    for (var i = 0; i < alphaList.length; i++) {
      _loop(i);
    }

    if (tagChange) {
      setAllCaps(capList);
    }

    return removeDuplicates(displayList);
  };

  var arrangeList = function arrangeList(list, previousCap) {
    var arrangedList = [];
    var numberList = [];
    var subList = [];
    var cap = '';

    if (list.length > 0) {
      if (list[0]['name'] !== undefined) {
        if (list[0].length > 0) {
          cap = list[0]['name'].substring(0, 1);
        }
      }
    }

    var checkedNumberList = false;

    for (var i = 0; i < list.length; i++) {
      var currentCap = list[i]['name'].substring(0, 1);

      if (/^[0-9]+$/.test(currentCap)) {
        numberList.push(list[i]); // console.log('here: ', numberList)

        if (i === list.length - 1) {
          arrangedList.push(numberList);
        }
      } else {
        // console.log('numberList: ', numberList)
        if (!checkedNumberList) {
          checkedNumberList = true;

          if (numberList.length > 0) {
            arrangedList.push(numberList);
          }

          cap = currentCap;
          subList.push(list[i]);

          if (i === list.length - 1) {
            arrangedList.push(subList);
          }
        } else {
          if (currentCap === cap) {
            subList.push(list[i]); // console.log('subList', subList, list[i], currentCap, cap)

            if (i === list.length - 1) {
              arrangedList.push(subList);
            }
          } else {
            cap = currentCap;
            arrangedList.push(subList);
            subList = [];
            subList.push(list[i]);
          }
        }
      }
    }

    return {
      arrangedList: arrangedList,
      previousCap: previousCap
    };
  };

  var updateList = function updateList(givenList, tagChange) {
    var brandsList = reOrderList(givenList, tagChange);
    var length = Math.floor(givenList.length / 3);
    var tempList1;
    var tempList2 = {
      arrangedList: [[{
        name: ' ',
        id: ''
      }]],
      previousCap: ''
    };
    var tempList3 = {
      arrangedList: [[{
        name: ' ',
        id: ''
      }]],
      previousCap: ''
    };

    if (length > 2) {
      tempList1 = arrangeList(brandsList.slice(0, length), '');
      tempList2 = arrangeList(brandsList.slice(length, length * 2), brandsList[length]['name'].substring(0, 1));
      tempList3 = arrangeList(brandsList.slice(length * 2), brandsList[length * 2]['name'].substring(0, 1));
    } else {
      tempList1 = arrangeList(brandsList);
    }

    setList1(tempList1);
    setList2(tempList2);
    setList3(tempList3);
  };

  var renderList = function renderList(listInfo) {
    var list = listInfo.arrangedList;
    return list.map(function (item) {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("div", {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
          style: {
            paddingBottom: 'unset',
            paddingTop: 'unset'
          },
          children: item[0]['name'].substring(0, 1) === listInfo.previousCap ? null : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
            id: /^[0-9]+$/.test(item[0]['name'].substring(0, 1)) ? '0-9' : item[0]['name'].substring(0, 1),
            style: {
              fontSize: 16,
              fontWeight: 700,
              fontFamily: 'Montserrat'
            },
            children: /^[0-9]+$/.test(item[0]['name'].substring(0, 1)) ? '0-9' : item[0]['name'].substring(0, 1)
          })
        }), item.map(function (nestedItem) {
          return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
            onClick: function onClick() {
              return checkDetail(nestedItem);
            },
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
              style: {
                cursor: 'pointer',
                fontSize: 12,
                fontWeight: 400,
                color: '#333333',
                fontFamily: 'Montserrat'
              },
              children: nestedItem['name']
            })
          }, nestedItem.id);
        })]
      }, item.id);
    });
  };

  var onChange = function onChange(e) {
    setSearchInput(e.target.value);
  };

  var onClickFind = function onClickFind() {
    var res = brandsName.filter(function (item) {
      return item['name'].toLowerCase().includes(searchInput.toLowerCase());
    });
    console.log('search res: ', res);

    if (res !== undefined) {
      updateList(res, false);
    }
  };

  var filterBrandsByType = function filterBrandsByType(type) {
    setSelectedType(type);

    if (type === 'ALL') {
      updateList(brandsName, true);
    } else {
      var filtered = brands.filter(function (item) {
        return item.bizType === type;
      });
      var filteredName = filtered.map(function (item) {
        return {
          "name": item.name,
          "id": item.id
        };
      });
      updateList(filteredName, true);
    }
  };

  var handleTagClick = function handleTagClick(tag) {
    setSelectedTag(tag);
    var filteredName = [];

    if (tag === '0-9') {
      filteredName = brandsName.filter(function (item) {
        return /^[0-9]+$/.test(item.name[0]);
      });
    } else {
      filteredName = brandsName.filter(function (item) {
        return item.name[0] === tag;
      });
    }

    updateList(filteredName, false);
  };

  var checkDetail = /*#__PURE__*/function () {
    var _ref2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(selectedBrand) {
      var brand;
      return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              brand = brands.find(function (item) {
                return item.id === selectedBrand.id || item.slug === selectedBrand.id;
              });
              console.log('found brand: ', brand);
              _context.next = 4;
              return router.push("".concat(brand.slug, "/").concat(brand.id));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function checkDetail(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (brandsName.length > 0) {
      updateList(brandsName, true);
      return function () {
        console.log('cleaned up');
      };
    }
  }, [brandsName]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    console.log('at all brands: ', brands);

    if (brands.length > 0) {
      var _brandsName = brands.map(function (item) {
        return {
          name: item.name,
          id: item.id
        };
      });

      if (_brandsName[0]['name'] !== undefined) {
        setBrandsName(_brandsName);
      }
    }
  }, [brands]);
  var type = [{
    name: 'brands_product_brands',
    value: 'PRODUCT'
  }, {
    name: 'brands_service_brands',
    value: 'SERVICE'
  }, {
    name: 'brands_store_clinic_brands',
    value: 'LOCATION'
  }, {
    name: 'brands_other_brands',
    value: 'OTHERS'
  }, {
    name: 'brands_all_brands',
    value: 'ALL'
  }];

  var _useState10 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isMobile = _useState10[0],
      setIsMobile = _useState10[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (loaded) {
      setIsMobile((0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__.checkMobile)());
    }
  }, [loaded]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("div", {
      style: {
        width: '100%',
        borderBottom: 'solid thin #DDDDDD'
      },
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(components_MyBreadcrumbs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          t: t,
          routeList: BREAD_ROUTE
        }), isMobile ? null : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("h1", {
          style: {
            letterSpacing: 3,
            marginTop: 30,
            marginBottom: 40,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 700,
            fontSize: 36
          },
          children: [t('home:brandBanner1'), "  ", (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
            sx: {
              marginLeft: 2,
              fontWeight: 400,
              textTransform: 'none',
              fontSize: 30
            },
            children: t('home:footer_slogan')
          })]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("nav", {
          className: isMobile ? (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)('flex', 'grow', 'shrink', 'min-w-0', 'overflow-scroll', 'mt-10') : (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)('flex', 'grow', 'shrink', 'min-w-0', 'overflow-hidden'),
          children: BRANDS_ROUTE.map(function (route) {
            return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
              href: route.href,
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("a", {
                style: {
                  fontSize: 14,
                  fontWeight: router.pathname === route.href ? 600 : 400,
                  borderBottom: router.pathname === route.href ? 'solid 2px #108085' : 'unset'
                },
                className: isMobile ? (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)('font-normal', 'mr-7', 'last:mr-0', 'leading-5') : (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)('font-normal', 'mr-7', 'last:mr-0', 'leading-10'),
                children: t("home:".concat(route.label))
              })
            }, route.label);
          })
        })]
      })
    }), loaded ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
      style: {
        marginTop: 50
      },
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("div", {
        style: {
          marginBottom: 20
        },
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP, {
          container: true,
          className: classes.root,
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP, {
            xs: 12,
            md: 6,
            lg: 3,
            item: true,
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("h1", {
              style: {
                fontSize: 14,
                fontWeight: 700,
                fontFamily: 'Montserrat'
              },
              children: t('home:brands_all_brands')
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(components_MyInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
              onChange: onChange,
              value: searchInput,
              handleClick: onClickFind,
              placeHolder: t('home:brands_find_a_brand'),
              margin: true
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("div", {
              style: {
                marginTop: 20
              },
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("h1", {
                style: {
                  fontSize: 14,
                  fontWeight: 700,
                  fontFamily: 'Montserrat'
                },
                children: 'A-Z'
              }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP, {
                container: true,
                style: {
                  minHeight: 100
                },
                children: allCaps.map(function (item) {
                  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP, {
                    xs: 2,
                    item: true,
                    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                      onClick: function onClick() {
                        return handleTagClick(item);
                      },
                      style: {
                        alignSelf: 'center',
                        cursor: 'pointer',
                        fontSize: 9,
                        fontWeight: selectedTag === item ? 700 : 500,
                        color: selectedTag === item ? '#18b8bf' : '#7C7C7C',
                        fontFamily: 'Montserrat',
                        lineHeight: 3
                      },
                      children: item
                    })
                  }, item);
                })
              })]
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("div", {
              style: {
                marginTop: 20
              },
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("h1", {
                style: {
                  fontSize: 14,
                  fontWeight: 700,
                  fontFamily: 'Montserrat'
                },
                children: t('home:product_browsebycategory')
              }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("div", {
                className: isMobile ? 'flex grid grid-cols-2 gap-3' : null,
                children: type.map(function (item) {
                  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    onClick: function onClick() {
                      return filterBrandsByType(item.value);
                    },
                    style: {
                      fontSize: 12,
                      fontWeight: selectedType === item.value ? 700 : 400,
                      color: selectedType === item.value ? '#18b8bf' : '#333333',
                      fontFamily: 'Montserrat',
                      lineHeight: 2,
                      cursor: 'pointer'
                    },
                    children: t("home:".concat(item.name))
                  }, item.name);
                })
              })]
            })]
          }), list1.arrangedList.length > 0 ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP, {
            className: isMobile ? 'mt-5' : null,
            item: true,
            xs: 12,
            md: 6,
            lg: list2.arrangedList.length > 0 ? list3.arrangedList.length > 0 ? 3 : 4 : 6,
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
              className: isMobile ? classes.mobileList : classes.list,
              children: renderList(list1)
            })
          }) : null, list2.arrangedList.length > 0 ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP, {
            item: true,
            xs: 12,
            md: 6,
            lg: list3.arrangedList.length > 0 ? 3 : 4,
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
              className: isMobile ? classes.mobileList : classes.list,
              children: renderList(list2)
            })
          }) : null, list3.arrangedList.length > 0 ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP, {
            item: true,
            xs: 12,
            md: 6,
            lg: 3,
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
              className: isMobile ? classes.mobileList : classes.list,
              children: renderList(list3)
            })
          }) : null]
        })
      })
    }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
      style: {
        marginTop: 50
      },
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("span", {
        children: t('home:loading')
      })
    })]
  });
}

AllBrands.getLayout = function getLayout(page) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(layouts_Default__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    children: page
  });
};

/***/ }),

/***/ 96052:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/allBrands",
      function () {
        return __webpack_require__(68721);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,196,6694,6886,7607,9774,2888,179], function() { return __webpack_exec__(96052); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);